import { connect } from 'react-redux'
import * as processAction from '../../../process/state/instance-detail/action'
import * as processSelector from '../../../process/state/instance-detail/selector'
import SupplierTrackingNumberWidget from './SupplierTrackingNumberWidget'


const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplierTrackingNumberWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/SupplierTrackingNumberWidgetContainer.js